import axios from "axios";
import { Message } from "element-ui";
import baseUrl from "./baseUrl";

const serviceAxios = axios.create({
    baseURL: baseUrl, // 基础请求地址
    timeout: 100000, // 请求超时设置
});

serviceAxios.interceptors.request.use(
    (config) => {
        // console.log("请求配置", config);
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);
serviceAxios.interceptors.response.use(
    (response) => {
        // console.log("响应结果", response);
        // const { data, code } = response.data;
        return response.data;
    },
    (error) => {
        Message.error(error.message);
        return Promise.reject(error);
    }
);

function request(options) {
    options.method = options.method || 'get'
    if (options.method.toLowerCase() == 'get') {
        options.params = options.data
    }
    return serviceAxios(options)
}
export default request